import styled, { css } from 'styled-components';
var ShortDetails = styled.div.withConfig({
  displayName: "ShortDetails",
  componentId: "sc-1hcvceo-0"
})(["align-self:center;justify-self:center;margin:0 auto;padding-bottom:6vw;padding-top:3vw;width:100%;", ""], function (_ref) {
  var showDivider = _ref.showDivider,
      isMobile = _ref.isMobile;
  return showDivider && isMobile && css(["padding-bottom:10vw;padding-top:1vw;"]);
});
export default ShortDetails;